import { makeStyles } from '@mui/styles';
import { palette } from '@livable/saas-react-components';
const useStyles = makeStyles({
  currentCompany: {
    textDecoration: 'none',
    textAlign: 'center',
    marginRight: '20px',
    lineHeight: '60px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    width: '120px'
  },
  testMode: {
    position: 'absolute',
    zIndex: '10',
    bottom: '-22px',
    left: '0',
    right: '0',
    textAlign: 'center',
    borderTop: "2px solid ".concat(palette.primary.main)
  },
  testModeText: {
    backgroundColor: palette.primary.main,
    padding: '2px 0',
    borderRadius: '0 0 4px 4px',
    display: 'block',
    width: '100px',
    margin: '0 auto',
    '& .MuiTypography-root': {
      fontSize: '11px',
      lineHeight: '16px'
    }
  },
  testModeToggle: {
    height: '60px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '20px'
  },
  sidebarMenuTrigger: {
    padding: '8px',
    minWidth: 'auto',
    boxShadow: 'none',
    backgroundColor: palette.shades[200],
    '&:hover': {
      backgroundColor: palette.shades[250]
    }
  },
  sidebarMenuTriggerIcon: {
    width: '24px',
    height: '24px',
    display: 'block',
    position: 'relative',
    '& i': {
      left: '3px',
      right: '3px',
      top: '5px',
      height: '2px',
      display: 'block',
      position: 'absolute',
      backgroundColor: palette.shades[700],
      '&:first-child': {
        top: '12px'
      },
      '&:last-child': {
        top: '19px'
      }
    }
  },
  contentL: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  contentR: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  notification: {
    height: '48px',
    minWidth: '48px'
  }
});
export default useStyles;